module.exports = __webpack_public_path__ + "static/media/outline-icons.ad97afd3.ttf";